export default [
  {
    path: '/external-bi/:reportRoute',
    name: 'external-bi',
    component: () => import('@/modules/external-bi/views/pages/ExternalBI.vue'),
    props: true,
    meta: {
      title: 'Mercafacil',
      pagePermission: 'home',
    },
  },
]
